<template>
	<div class="search-from">
		<xl-form :model="searchForm" inline>
			<xl-form-item v-for="param in searchParams" :key="param.key" :props="[param.key]" v-show="( param.component && checkedColumns.includes( param.key )) || param.fixed">
				<component :is="param.component" v-bind="param.bind" v-model="searchForm[param.key]" v-on="param.event"/>
			</xl-form-item>
		</xl-form>
	</div>
</template>

<script setup>
import { XlForm, XlFormItem } from '@shining3d/ui-components';
import { ref, computed } from 'vue';

const props = defineProps({
	modelValue: {
		type: Object,
		default: () => ({})
	},
	searchParams: {
		type: Array,
		default: () => []
	},
	checkedColumns: {
		type: Array,
		default: () => []
	}
});

const emits = defineEmits(['update:modelValue']);

const searchForm = computed({
	get: () => props.modelValue,
	set: ( val ) => {
		emits( 'update:modelValue', val );
	}
});
</script>
<style scoped lang="scss">
.el-form--inline .el-form-item {
	margin-right: 8px;
}
.el-form-item--large{
	margin-bottom: 8px !important;
}
.search-from{
	max-width: 700px;
	margin-bottom: 16px;
}
</style>
